module.exports = __webpack_public_path__ + "assets/images/e3b81ffcc7213e1fb68e7179c13ce509.png";